import { DNA_HOW_IT_WORKS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './DnaHowItWorks'

export default withLocalization(Component, DNA_HOW_IT_WORKS)
